import Controller from '@ember/controller';

import { isDevelopingApp, macroCondition } from '@embroider/macros';
import { ToastRegion } from '@repo/design-system-kit';

import ENV from 'receivable-invoices-js/config/environment';

export default class ApplicationController extends Controller {
  toastRegion = ToastRegion;

  constructor() {
    super(...arguments);
    if (macroCondition(isDevelopingApp())) {
      document.title = 'Qonto - dev';
    } else {
      // eslint-disable-next-line no-console
      console.log('app version:', ENV.qontoAppVersion);
    }
  }
}
